module.exports = __webpack_public_path__ + "CatHandOnHip-d01afcfbb91014c9fd467fdab10f519a.svg";